import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  cancelled() {
    return faker.datatype.boolean();
  },

  dgg() {
    return faker.datatype.boolean();
  },

  headline() {
    return `${faker.music.songName()} Tour`;
  },

  internalRemarks() {
    return faker.lorem.paragraph();
  },

  repertoire() {
    return faker.lorem.paragraph();
  },

  secret() {
    return faker.datatype.boolean();
  },

  startDate() {
    return faker.date.future();
  },

  startTime() {
    return faker.lorem.paragraph();
  },

  tbc() {
    return faker.datatype.boolean();
  },

  text() {
    return faker.datatype.boolean();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(liveEvent, server) {
    liveEvent.update({
      artists: server.createList('artist', 1),
      locationPartners: server.createList('live-partner', 1),
      presenterPartners: server.createList('live-partner', 1),
      type: server.create('category'),
    });
  },
});
